'use client';

import { PropsWithChildren, useEffect, useRef, useState } from 'react';

import { createPortal } from 'react-dom';

interface Props extends PropsWithChildren {
   selector: string;
}

/* istanbul ignore next */
export const ClientPortal = ({ selector, children }: Props) => {
   const ref = useRef<Element | null>(null);
   const [mounted, setMounted] = useState(false);

   useEffect(() => {
      const result = document.querySelector(selector);
      ref.current = result;
      setMounted(!!result);
   }, [selector]);

   return mounted && ref.current ? createPortal(children, ref.current) : null;
};
